import { shipping, brand } from "../content/site";
import { PageHeader } from "../components/PageHeader";
import { Reveal, Eyebrow } from "../components/Reveal";

export default function Shipping() {
  return (
    <div data-testid="shipping-page">
      <PageHeader
        eyebrow="Shipping & Returns"
        title="Delivery, without fuss."
        body="How your order reaches you, and how returns work if you change your mind. Launch delivery pricing will be confirmed here before orders open."
      />
      <section className="mx-auto max-w-4xl space-y-16 px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
        <Reveal>
          <Eyebrow>Delivery options</Eyebrow>
          <div className="mt-8 overflow-x-auto">
            <table data-testid="shipping-table" className="w-full text-sm">
              <thead>
                <tr className="border-b border-stone-900/20 text-left font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500">
                  <th className="py-3 pr-4 font-medium">Service</th>
                  <th className="py-3 pr-4 font-medium">Estimate</th>
                  <th className="py-3 font-medium">Cost</th>
                </tr>
              </thead>
              <tbody>
                {shipping.options.map((o) => (
                  <tr key={o.name} className="border-b border-stone-900/10">
                    <td className="py-4 pr-4 text-stone-900">{o.name}</td>
                    <td className="py-4 pr-4 text-stone-600">{o.detail}</td>
                    <td className="py-4 font-mono text-xs text-stone-600">{o.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-stone-600">{shipping.dispatch}</p>
        </Reveal>

        <Reveal>
          <Eyebrow>Returns</Eyebrow>
          <p className="mt-8 text-base leading-relaxed text-stone-600">{shipping.returns}</p>
        </Reveal>

        <Reveal>
          <Eyebrow>Damaged or incorrect orders</Eyebrow>
          <p className="mt-8 text-base leading-relaxed text-stone-600">
            If something arrives damaged or is not what you ordered, contact us at{" "}
            <a href={`mailto:${brand.email}`} className="text-emerald-900 underline underline-offset-4">
              {brand.email}
            </a>{" "}
            with your order number and a photo where possible. We will put it right — replacement or refund, your
            choice.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
